import { ColorTypes } from '@genial/design-tokens';

export const screenName = 'customer-detail';

export const productDistributionColor: {
  [key: string]: ColorTypes.Option;
} = {
  1: 'product.fundos',
  2: 'product.clubes',
  3: 'product.rf',
  4: 'product.rendavariavel',
  5: 'product.previdencia',
  6: 'product.tesouro',
  7: 'product.estruturados',
  8: 'product.cripto',
};

export const getProductDistributionColor = (key?: string | null): ColorTypes.Option => {
  if (!key || !productDistributionColor[key]) {
    return 'neutral.light';
  }
  return productDistributionColor[key];
};
